import { ResponseHandler, ResultType } from '../types';
import { nativeHistogramResponseHandler, timeSeriesHistogramResponseHandler } from './heatmap-response-handler';
import { timeSeriesHandler } from './timeseries-response-handler';

export const distributionResponseHandler: ResponseHandler = {
  [ResultType.NativeHistogram]: (result, metadata, notices, context) => {
    const heatmapResponse = nativeHistogramResponseHandler(result, metadata, notices, context);

    // Wrap the heatmap response in a distribution response
    return {
      type: 'Distribution',
      data: {
        ...heatmapResponse.data,
        distributionKind: 'HeatMap',
      },
    };
  },
  [ResultType.TimeSeriesHistogram]: (result, metadata, notices, context) => {
    const heatmapResponse = timeSeriesHistogramResponseHandler(result, metadata, notices, context);

    // Wrap the heatmap response in a distribution response
    return {
      type: 'Distribution',
      data: {
        ...heatmapResponse.data,
        distributionKind: 'HeatMap',
      },
    };
  },
  [ResultType.TimeSeries]: (result, metadata, notices, context) => {
    const timeSeriesData = timeSeriesHandler(result, metadata, notices, context);

    return {
      type: 'Distribution',
      data: {
        ...timeSeriesData.data,
        distributionKind: 'TimeSeries',
      },
    };
  },
};
